<template>
  <div class="flex items-center justify-center min-h-screen bg-gray-100">
    <div class="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow">
      <h2 class="text-2xl font-bold text-center">Reset Password</h2>
      <div v-if="errors.key">
        <div v-for="error in errors.key" :key="error" class="text-red-600">{{ error }}</div>
      </div>
      <form v-if="!errors.key" @submit.prevent="resetPassword">
        <div class="space-y-4">
          <div>
            <label class="block text-sm font-medium" for="password">Password</label>
            <input
              id="password"
              v-model="password"
              class="w-full px-3 py-2 border rounded"
              type="password"
              required
            />
            <Password_Requirements :password="password" />
            <Field_Errors :received_errors="errors.password" />
          </div>
          <div>
            <label class="block text-sm font-medium" for="password_confirm">Confirm Password</label>
            <input
              id="password_confirm"
              v-model="password_confirm"
              class="w-full px-3 py-2 border rounded"
              type="password"
              required
            />
            <Field_Errors :received_errors="errors.password_confirm" />
          </div>
        </div>
        <div class="flex items-center justify-between mt-6">
          <Field_Errors :received_errors="errors.non_field_errors" />
          <button
            class="px-4 py-2 text-white bg-primary-500 rounded hover:bg-primary-500"
            :disabled="!isPasswordConfirmMatch"
            type="submit"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { useToast } from 'vue-toastification';

import Field_Errors from '@/components/widgetcomponents/Field_Errors.vue'
import Password_Requirements from '@/components/widgetcomponents/Password_Requirements.vue'
import { makeAllauthRequestAndParseErrors } from '@/utils/auth';

export default {
  components: {
    Field_Errors,
    Password_Requirements,
  },
  props: {
    verificationKey: {
      type: String,
      required: true
    },
  },
  data(){
    return {
      password: '',
      password_confirm: '',
      errors: {},
    }
  },
  computed: {
    toast() {
      return useToast();
    },
    isPasswordConfirmMatch() {
      return this.password === this.password_confirm;
    }
  },
  methods: {
    async resetPassword() {
      try {
        this.errors = {}
        await makeAllauthRequestAndParseErrors({
          method: 'post',
          url: '_allauth/browser/v1/auth/password/reset',
          data: {
            key: this.verificationKey,
            password: this.password,
          }
        })
        this.toast.success('Password reset — please sign in')
        this.$router.push({name:'Login'})
      } catch (error) {
        if (error.fieldBasedErrors) {
          this.errors = error.fieldBasedErrors
        } else {
          throw error
        }
      }
    },
    setPasswordConfirmErrors() {
      if (this.isPasswordConfirmMatch) {
        this.errors.password_confirm = [];
      } else {
        this.errors.password_confirm = ['New password and confirmation do not match'];
      }
    }
  },
  watch: {
    password() {
      this.setPasswordConfirmErrors();
    },
    password_confirm() {
      this.setPasswordConfirmErrors();
    }
  },
  async mounted() {
    try {
      await makeAllauthRequestAndParseErrors({
        method: 'get',
        url: '_allauth/browser/v1/auth/password/reset',
        headers: { 'X-Password-Reset-Key': this.verificationKey }
      })
    } catch(error) {
      if (error.fieldBasedErrors) {
        this.errors = error.fieldBasedErrors
      } else {
        throw error
      }
    }
  }
}
</script>
